import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { MailMerge } from '@quorum/models/xs-resource';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';

export interface MailMergesState extends EntityState<MailMerge> {}

export const mailMergesAdapter: EntityAdapter<MailMerge> = createEntityAdapter<MailMerge>({
  selectId: (mailMerge: MailMerge) => mailMerge.id,
});

export const initialState: MailMergesState = mailMergesAdapter.getInitialState({});

export const mailMergesSelector = createSelector(svcDropdownsFeatureSelector, (state: any) => state.mailMerges);

export const { selectIds, selectEntities, selectAll, selectTotal } = mailMergesAdapter.getSelectors(mailMergesSelector);
